module.exports = __webpack_public_path__ + "img/mexico-flag.0737629c.png";